import {
  Checkbox,
  FormControlLabel,
  IconButton,
  ListItem,
  Tooltip,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import UserSmallHeader from 'components/Headers/UserSmallHeader';
import Proposta from 'models/Proposta';
import { PropostaMaterial } from 'models/PropostaGNFOracle';
import { PropostaVersao } from 'models/PropostaVersao';
import SequenciaTipoOrdemVendaModel from 'models/SequenciaTipoOrdemVenda';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { FaInfoCircle, FaSpinner } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import {
  Button,
  Card,
  CardHeader,
  Col,
  Collapse,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap';
import api from 'services/api';
import Swal from 'sweetalert2';
import Cabecalho from '../Proposta/components/Cabecalho';
import './style.css';

interface LocationState {
  proposta: Proposta;
  propostaVersao: PropostaVersao;
}

interface iListaDados {
  id: string;
  idPai: string;
  descricao: string;
  isOpen: boolean;
  isSelecionavel: boolean;
  ordemVenda: string | null;
  tipoOrdemVenda: string | null;
  setorAtividade: string | null;
  nomeProduto?: string | null;
}

interface iProcessamento {
  titulo: string;
  status: string;
  mensagem: string;
}

interface iSelecionados {
  id: string;
  descricao: string;
  idPai: string;
  isOpen: boolean;
  orcamentoId: number;
  propostaVersaoId: number;
  ordemVenda: string | null;
  tipoOrdemVenda: string | null;
  setorAtividade: string | null;
  isSelecionavel: boolean;
  nomeProduto?: string | null;
}

function GerarGNF(): JSX.Element {
  const location = useLocation<LocationState>();
  const { propostaVersao } = location.state;

  const [isLoading, setIsLoading] = useState(false);
  const [raizTipoOrdemVenda, setRaizTipoOrdemVenda] = useState<number>(0);
  const [filtroOrdemVenda, setFiltroOrdemVenda] = useState('');
  const [listaTipoOrdemVendaRaiz, setListaTipoOrdemVendaRaiz] = useState<
    SequenciaTipoOrdemVendaModel[]
  >([]);

  const [geradoOficial, setGeradoOficial] = useState(false);

  const [lista, setLista] = useState<iListaDados[]>([]);
  const [paisInconsistentes, setPaisInconsistentes] = useState<string[]>([]);

  const listaEstruturaChave = lista.map(i => `${i.idPai}:${i.id}`).join('|');

  useEffect(() => {
    const inconsistentes: string[] = [];

    // Monta mapa de pai -> filhos diretos
    const paiFilhos = new Map<string, iListaDados[]>();
    lista.forEach(item => {
      if (item.idPai) {
        if (!paiFilhos.has(item.idPai)) paiFilhos.set(item.idPai, []);
        paiFilhos.get(item.idPai)!.push(item);
      }
    });

    lista.forEach(pai => {
      if (pai.idPai !== '') return;

      const filhos = paiFilhos.get(pai.id) || [];
      if (filhos.length === 0) return;

      const seqsPorPrefixo: Record<string, number[]> = {};
      filhos.forEach(f => {
        const match = f.id.match(/\.([A-Za-z]+)(\d+)$/);
        if (match) {
          const prefix = match[1];
          const seqVal = parseInt(match[2], 10);
          if (!seqsPorPrefixo[prefix]) seqsPorPrefixo[prefix] = [];
          seqsPorPrefixo[prefix].push(seqVal);
        }
      });

      const gap = Object.keys(seqsPorPrefixo).some(prefix => {
        const seqs = [...seqsPorPrefixo[prefix]].sort((a, b) => a - b);
        if (seqs[0] !== 1) return true;
        return seqs.some(
          (seq, i) => i < seqs.length - 1 && seqs[i + 1] !== seq + 1,
        );
      });

      if (gap) inconsistentes.push(pai.id);
    });

    setPaisInconsistentes(inconsistentes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listaEstruturaChave]);

  const [isInformacoesCarregadas, setIsInformacoesCarregadas] = useState(false);

  const [isProcessoParalelo, setIsProcessoParalelo] = useState(false);
  const [isGerandoOficial, setIsGerandoOficial] = useState(false);
  const [pVersao, setPVersao] = useState<PropostaVersao>(propostaVersao);
  const [listaProcessamento, setListaProcessamento] = useState<
    iProcessamento[]
  >([]);
  const [resultadosOrdemVenda, setResultadosOrdemVenda] = useState<any[]>([]);

  const isGeneratingOvRef = useRef(false);
  const todosGeradosComSucesso =
    resultadosOrdemVenda.length > 0 &&
    resultadosOrdemVenda.every(r => r.sucesso);

  const badgeProcessamento = [
    {
      status: 'S',
      texto: 'Sucesso',
      color: 'success',
    },
    {
      status: 'A',
      texto: 'Andamento',
      color: 'warning',
    },
    {
      status: 'E',
      texto: 'Erro',
      color: 'danger',
    },
    {
      status: 'P',
      texto: 'Pendente',
      color: 'info',
    },
  ];

  const [isModalOrdemVendaOpen, setIsModalOrdemVendaOpen] = useState(false);

  const [configuracaoTela, setConfiguracaoTela] = useState<{
    geraEspelho: boolean;
    habilitaEspelho: boolean;
    habilitaGeracao: boolean;
    texto: string;
    tipoGerar: string;
  }>({
    tipoGerar: 'GNF',
    geraEspelho: true,
    texto: 'GNF Final',
    habilitaEspelho: true,
    habilitaGeracao: true,
  });

  const [listaMateriaisInvalidos, setListaMateriaisInvalidos] = useState<
    PropostaMaterial[]
  >([]);

  const [selecionados, setSelecionados] = useState<iSelecionados[]>([]);

  const handleToggle = (item: any) => {
    setSelecionados(prev => {
      const existe = prev.find(i => i.id === item.id);

      if (existe) {
        return prev.filter(i => i.id !== item.id);
      }

      return [...prev, item];
    });
  };

  async function carregarTiposRaiz() {
    const response = await api.get(
      '/integracao/sequencia-tipo-ordem-venda/tipos-raiz',
    );

    setListaTipoOrdemVendaRaiz(response.data);
  }

  async function getPropostaVersao() {
    setIsLoading(true);
    Swal.fire({
      icon: 'info',
      text: `Buscando informação da proposta`,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
    const response = await api.get(`/proposta/versao/${propostaVersao.id}`);
    setPVersao(response.data);
    Swal.close();
    setIsLoading(false);
  }

  async function getDadosMostrar() {
    setIsLoading(true);
    const response = await api.get(
      `/proposta-negocio/${pVersao.id}/listar?tipo=${configuracaoTela.tipoGerar}`,
      {},
    );

    setLista(response.data || []);
    setIsLoading(false);
  }

  async function getDadosPs(refresh = false) {
    setIsLoading(true);
    const toastId = toast.loading('Carregando dados...');
    const response = await api.get(
      `/proposta-negocio/${pVersao.id}/buscar-informacao-ps`,
      {},
    );

    const { oficialGerado, dados } = response.data;
    const list = (dados || []) as iProcessamento[];

    let gerado = false;
    let temErro = false;

    if (list && list.length > 0) {
      temErro = list.some(item => item.status === 'E');

      if (
        list.filter(item => item.status === 'S')?.length !== list.length &&
        !temErro
      ) {
        gerado = true;
      }
    }

    if (refresh && !temErro && oficialGerado) {
      window.location.reload();
      return;
    }

    setIsGerandoOficial(gerado);
    setListaProcessamento(list);
    setIsLoading(false);
    toast.dismiss(toastId);
  }

  async function atualizarInformacoesNegocio(onlySap = false) {
    Swal.fire({
      icon: 'info',
      text: `Atualizando informações do negócio...`,
      allowOutsideClick: false,
      showConfirmButton: false,
    });

    await api.post(
      `/proposta-negocio/${pVersao.id}/atualizar-dados?${
        onlySap ? `apenasCodigoSap=S` : ''
      }`,
      {},
    );
  }

  async function validaGeraGnf() {
    setIsLoading(true);

    Swal.fire({
      icon: 'info',
      text: `Buscando informação de produtos`,
      allowOutsideClick: false,
      showConfirmButton: false,
    });

    try {
      const produtognf = await api.get(
        `/proposta-negocio/${pVersao.id}/valida-produto-gnf`,
        {},
      );

      const dadosOficiais = produtognf.data.oficialGerado ?? false;
      setGeradoOficial(dadosOficiais);

      if (produtognf.data.geraPS) {
        setConfiguracaoTela({
          geraEspelho: true,
          tipoGerar: 'PS',
          texto: 'Cronograma/PS',
          habilitaGeracao: true,
          habilitaEspelho: true,
        });
        // if (!dadosOficiais)
        await getDadosPs();
      } else if (produtognf.data.geraPedido) {
        setConfiguracaoTela({
          geraEspelho: false,
          tipoGerar: 'PED',
          texto: 'Pedido',
          habilitaGeracao: true,
          habilitaEspelho: true,
        });
      } else if (produtognf.data.geraGnf) {
        setConfiguracaoTela({
          geraEspelho: true,
          tipoGerar: 'GNF',
          texto: 'GNF Final',
          habilitaGeracao: true,
          habilitaEspelho: true,
        });
      }

      setIsInformacoesCarregadas(true);
    } finally {
      setIsLoading(false);
      Swal.close();
    }
  }

  async function processarGnf(espelho: boolean, atualizarInfo = true) {
    setIsLoading(true);
    if (atualizarInfo) await atualizarInformacoesNegocio();

    Swal.fire({
      icon: 'info',
      text: `Gerando ${configuracaoTela.texto} ${
        espelho ? '- Espelho' : ''
      }...`,
      allowOutsideClick: false,
      showConfirmButton: false,
    });

    const procParalelo = false;

    try {
      const retorno = await api.post(
        `/proposta-negocio/${pVersao.id}/gerar-negocio`,
        {
          listaMateriaisInvalidos,
          possuiInformacoesPendentes: false,
          tipo: configuracaoTela.tipoGerar,
          isEspelho: espelho,
        },
      );

      const temProcessamentoParalelo =
        retorno.data.temProcessamentoParalelo ?? false;

      if (temProcessamentoParalelo && retorno.data.integracaoId) {
        const confirmacao = await Swal.fire({
          icon: 'info',
          text: `O processo de integração está sendo executado em paralelo e pode demorar. Vá atualizando a página para acompanhar o status do processo.`,
          allowOutsideClick: false,
          showConfirmButton: true,
        });
      } else {
        Swal.close();
      }
    } catch (error: any) {
      const data = await Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    } finally {
      if (!procParalelo) {
        await validaGeraGnf();
        await getDadosMostrar();
        setIsLoading(false);
      }
    }
  }

  function handleProcessar(isEspelho = false) {
    // Bloqueia a geração oficial quando há inconsistências de sequência
    if (!isEspelho && paisInconsistentes.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Sequência Inconsistente',
        text: 'Não é possível gerar o PS oficial enquanto houver itens com sequências de atividades inconsistentes. Corrija as lacunas indicadas e recarregue o espelho antes de prosseguir.',
      });
      return;
    }

    let pularEspelho = false;
    if (!configuracaoTela.geraEspelho) {
      pularEspelho = true;
    }

    Swal.fire({
      title: `Deseja executar o processamento para gerar ${
        isEspelho && !pularEspelho ? `Espelho de` : ``
      }${configuracaoTela.texto}?`,
      text: `O processo pode demorar um pouco.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        await processarGnf(isEspelho && !pularEspelho);
      }
    });
  }

  async function handleGerarOrdemVenda() {
    if (isGeneratingOvRef.current || isLoading) return;
    isGeneratingOvRef.current = true;
    setIsLoading(true);

    try {
      // Vai atualizar os dados
      await atualizarInformacoesNegocio();

      Swal.fire({
        icon: 'info',
        text: `Gerando OV`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      setResultadosOrdemVenda([]); // Limpa resultados anteriores caso clique novamente

      const retorno = await api.post(
        `/proposta-negocio/${pVersao.id}/gerar-ordem-venda`,
        {
          raizTipoOrdemVenda,
          selecionados,
        },
      );

      // Salva o retorno (Array de sucesso/erro) no estado para as badges lerem
      setResultadosOrdemVenda(retorno.data || []);

      Swal.close();
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text:
          error?.response?.data?.message ||
          'Ocorreu um erro crítico na requisição.',
      });
    } finally {
      await getDadosMostrar();
      setIsLoading(false);
      isGeneratingOvRef.current = false;
      // Mantém o modal aberto para que o usuário veja os badges de sucesso/erro
    }
  }

  function handleCloseModal() {
    if (!isLoading && !isGeneratingOvRef.current) {
      setIsModalOrdemVendaOpen(false);

      // Only clear the selections if the process actually ran and generated results
      if (resultadosOrdemVenda.length > 0) {
        setSelecionados([]);
        setResultadosOrdemVenda([]);
        setRaizTipoOrdemVenda(0);
      }
    }
  }

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
    getPropostaVersao();
    validaGeraGnf();
    carregarTiposRaiz();
  }, []);

  useEffect(() => {
    if (isInformacoesCarregadas) getDadosMostrar();
  }, [isInformacoesCarregadas]);

  function getStatusElemPep(elemento: string, nivel = 0) {
    if (configuracaoTela.tipoGerar !== 'PS') return '';

    if (geradoOficial || !listaProcessamento || listaProcessamento.length === 0)
      return '';

    if (nivel === 0) {
      const registro = listaProcessamento.filter(item =>
        item.titulo.includes(elemento),
      );

      let codigoBuscar = 'P';

      if ((registro.filter(item => item.status === 'E')?.length ?? 0) > 0)
        codigoBuscar = 'E';
      else if (
        registro.length > 0 &&
        (registro.filter(item => item.status === 'S')?.length ?? 0) ===
          registro.length
      )
        codigoBuscar = 'S';
      else if (
        (registro.filter(item => item.status === 'A')?.length ?? 0) > 0 ||
        ((registro.filter(item => item.status === 'P')?.length ?? 0) > 0 &&
          (registro.filter(item => item.status === 'S')?.length ?? 0) > 0)
      )
        codigoBuscar = 'A';

      const status = badgeProcessamento.find(
        item2 => item2.status === codigoBuscar,
      );

      return (
        <div
          className={`badge badge-${status?.color}`}
          title={`${codigoBuscar === 'E' ? 'Algum erro ocorreu.' : ''}`}
        >
          {status?.texto}
        </div>
      );
    }

    const registro = listaProcessamento.find(item =>
      item.titulo.includes(elemento),
    );

    const status = badgeProcessamento.find(
      item2 => item2.status === registro?.status,
    );

    return (
      <div
        className={`badge badge-${status?.color}`}
        title={`${registro?.mensagem ?? ''}`}
      >
        {status?.texto}
      </div>
    );
  }

  function renderListaVersao(item: iListaDados, nivel = 0) {
    const { isOpen } = item;

    function handleToggleAccordion() {
      setLista(
        lista.map(x => (x.id === item.id ? { ...x, isOpen: !x.isOpen } : x)),
      );
    }

    function renderExpand() {
      return isOpen ? (
        <ExpandLess onClick={handleToggleAccordion} />
      ) : (
        <ExpandMore onClick={handleToggleAccordion} />
      );
    }

    const listaFilhos = lista?.filter(itemx => itemx.idPai === item.id);

    const isDisabled = !item.isSelecionavel;
    // && selecionados.length > 0
    //  && selecionados[0]?.setorAtividade !== item.setorAtividade;

    const opacity = isDisabled ? 0.5 : 1;

    return (
      <div key={`item_${item.id}`}>
        <ListItem
          style={{
            borderBottom: '1px dashed #b1b1b1',
            marginLeft: `${nivel * 10}px`,
            paddingLeft: '2px',
            paddingRight: '2px',
          }}
        >
          <Row style={{ width: '100%' }}>
            <Col
              sm="4"
              style={{
                opacity,
              }}
            >
              <h3 className="mb-0">
                {item.descricao}{' '}
                {item.nomeProduto ? ` - ${item.nomeProduto}` : ''}
                {paisInconsistentes.includes(item.id) && (
                  <span
                    className="badge badge-danger ml-2"
                    title="As atividades possuem inconsistências nas sequências"
                  >
                    Sequência Inconsistente
                  </span>
                )}
              </h3>
            </Col>

            <Col
              sm="2"
              style={{
                opacity,
              }}
            >
              {getStatusElemPep(item.descricao, nivel)}
            </Col>
            <Col
              sm="1"
              style={{
                opacity,
              }}
            >
              {item.setorAtividade}
            </Col>

            <Col sm="5">
              <div hidden={!listaFilhos.length} className="float-right">
                Expandir {renderExpand()}
              </div>

              <div className="float-right ">
                {' '}
                <FormControlLabel
                  className="mt-0 mb-0 pt-0 pb-0"
                  hidden={item.ordemVenda !== null}
                  disabled={isDisabled}
                  control={
                    <Checkbox
                      style={{ padding: 0 }}
                      checked={selecionados.some(i => i?.id === item.id)}
                      onChange={() => handleToggle(item)}
                      color="primary"
                    />
                  }
                  label=""
                />
                <h3 className="mb-0">
                  <div className="" hidden={!item.ordemVenda}>
                    Nº/tipo da OV {item.ordemVenda} - {item.tipoOrdemVenda}
                  </div>
                </h3>
              </div>
            </Col>
          </Row>
        </ListItem>

        {listaFilhos.length > 0 && (
          <Collapse isOpen={isOpen}>
            {listaFilhos.map(itemx => renderListaVersao(itemx, nivel + 1))}
          </Collapse>
        )}
      </div>
    );
  }

  const isSalesOrderHidden =
    !geradoOficial || configuracaoTela.tipoGerar !== 'PS';

  function renderConteudoBotaoOrdemVenda() {
    if (isLoading) {
      return (
        <>
          <FaSpinner className="spinner mr-2" /> Processando...
        </>
      );
    }
    if (todosGeradosComSucesso) {
      return 'Ordens Geradas com Sucesso';
    }
    return 'Gerar Ordem de Venda';
  }

  return (
    <>
      <Modal
        isOpen={isModalOrdemVendaOpen}
        backdrop={isLoading ? 'static' : true}
        keyboard={!isLoading}
        toggle={handleCloseModal}
        size="lg"
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={handleCloseModal}>
          Gerar ordens de venda
        </ModalHeader>
        <ModalBody>
          {/* SELECTOR NO TOPO */}
          <Row>
            <Col sm="12">
              <FormGroup
                className="text-left"
                hidden={selecionados.length === 0}
              >
                <Label>Tipo Ordem de Venda</Label>
                <Input
                  type="select"
                  value={raizTipoOrdemVenda}
                  onChange={e => setRaizTipoOrdemVenda(Number(e.target.value))}
                  disabled={isLoading || todosGeradosComSucesso}
                >
                  <option value={0}>Selecione...</option>
                  {listaTipoOrdemVendaRaiz.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.codigoTipo}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col sm="12">
              Foram selecionados <strong>{selecionados.length}</strong> produtos
            </Col>
          </Row>

          {/* LISTA DE PRODUTOS COM SCROLL */}
          <div
            style={{
              maxHeight: '40vh',
              overflowY: 'auto',
              paddingRight: '5px',
            }}
          >
            <Row className="m-0">
              {selecionados.map((item, index) => {
                // Procura na resposta da API se há um resultado para o item específico ou setor
                const resultadoProcessamento = resultadosOrdemVenda.find(res =>
                  res.itemId
                    ? String(res.itemId) === String(item.id)
                    : res.setor === item.setorAtividade,
                );

                return (
                  <Col sm="12" key={`${item.id}-${index}`} className="mb-2 p-0">
                    <div className="border rounded p-2 d-flex justify-content-between align-items-center">
                      <span className="font-weight-bold">
                        {item.descricao}{' '}
                        {item.nomeProduto ? ` - ${item.nomeProduto}` : ''}
                      </span>

                      {resultadoProcessamento &&
                        (resultadoProcessamento.sucesso ? (
                          <Tooltip
                            title={
                              <span style={{ fontSize: '14px' }}>
                                {resultadoProcessamento.ordensVenda}
                              </span>
                            }
                            placement="top"
                          >
                            <div className="badge badge-success px-3 py-2">
                              Sucesso
                            </div>
                          </Tooltip>
                        ) : (
                          <Tooltip
                            title={
                              <span style={{ fontSize: '14px' }}>
                                {resultadoProcessamento.erro?.value ||
                                  resultadoProcessamento.erro ||
                                  'Erro desconhecido'}
                              </span>
                            }
                            placement="top"
                          >
                            <div
                              className="badge badge-danger px-3 py-2"
                              style={{ cursor: 'help' }}
                            >
                              Erro <FaInfoCircle className="ml-1" />
                            </div>
                          </Tooltip>
                        ))}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>

          {/* TEXTO INFORMATIVO E BOTÃO NO RODAPÉ */}
          <Row className="mt-2 text-center">
            <Col sm="12">
              <Button
                className="btn-icon btn-2 "
                color={todosGeradosComSucesso ? 'success' : 'primary'}
                type="button"
                outline={!todosGeradosComSucesso}
                hidden={selecionados.length === 0}
                disabled={
                  isLoading ||
                  raizTipoOrdemVenda === 0 ||
                  todosGeradosComSucesso
                }
                onClick={() => handleGerarOrdemVenda()}
              >
                {renderConteudoBotaoOrdemVenda()}
              </Button>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col sm="12">
              <small className="text-muted font-weight-bold">
                Será disparado processo para geração de ordem de venda para os
                itens selecionados. O processo pode demorar um pouco. Deseja
                prosseguir?
              </small>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <UserSmallHeader />
      {paisInconsistentes.length > 0 && (
        <div className="alert alert-warning mx-4 mt-4" role="alert">
          <strong>Aviso:</strong> O espelho gerado possui itens com sequências
          de atividades inconsistentes. É necessário corrigir as sequências de
          atividades para prosseguir.
        </div>
      )}
      <Card>
        <CardHeader>
          <Cabecalho />
          <h5 className="h3 mb-0" style={{ marginTop: '32px' }}>
            Geração {configuracaoTela.texto}
          </h5>
        </CardHeader>

        <Card className="shadow pt-3 pb-2 px-2 mt-1 mb-0 mx-1">
          <Row>
            {configuracaoTela.geraEspelho && (
              <Col sm="4">
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  outline
                  disabled={isLoading || isGerandoOficial}
                  hidden={configuracaoTela.tipoGerar !== 'PS' || geradoOficial}
                  onClick={() => handleProcessar(true)}
                >
                  Carregar Dados Espelho
                </Button>
              </Col>
            )}

            <Col sm="4">
              <Button
                className="btn-icon btn-2"
                color="primary"
                type="button"
                outline
                disabled={
                  isLoading || isGerandoOficial || paisInconsistentes.length > 0
                }
                hidden={configuracaoTela.tipoGerar !== 'PS' || geradoOficial}
                onClick={() => handleProcessar(false)}
              >
                Gerar {configuracaoTela.texto}
              </Button>
            </Col>
            <Col
              sm="4"
              className="mt-2"
              hidden={
                // geradoOficial ||
                !listaProcessamento || listaProcessamento.length === 0
              }
            >
              <Button
                className="btn-icon btn-2"
                color="primary"
                title="atualizar lista para acompanhar processamento"
                type="button"
                outline
                hidden={
                  geradoOficial ||
                  !listaProcessamento ||
                  listaProcessamento.length === 0
                }
                disabled={isLoading}
                onClick={() => getDadosPs(true)}
              >
                Atualizar
              </Button>
            </Col>

            <Col hidden={isSalesOrderHidden} sm="4">
              <Button
                className="btn-icon btn-2"
                color="primary"
                type="button"
                outline
                hidden={selecionados.length === 0}
                // onClick={() => setIsModalOrdemVendaOpen(prev => !prev)}
                onClick={() => {
                  setResultadosOrdemVenda([]);
                  setIsModalOrdemVendaOpen(true);
                }}
              >
                Gerar Ordem de Venda
              </Button>
            </Col>
          </Row>
        </Card>

        <Card className="shadow pt-3 pb-2 px-2 mt-1 mb-0 mx-1">
          <Row>
            <Col sm="10">
              <h3 className="mt-4">
                {configuracaoTela.texto}{' '}
                {geradoOficial
                  ? '- Dados Reais Gerados'
                  : '- Dados de Espelho/Simulação'}
                <span
                  className="float-right"
                  hidden={
                    // geradoOficial ||
                    !listaProcessamento || listaProcessamento.length === 0
                  }
                >
                  Etapas PS e ECP:{' '}
                  {listaProcessamento.filter(item => item.status === 'S')
                    ?.length ?? 0}{' '}
                  / {listaProcessamento.length}
                </span>
              </h3>
            </Col>

            <Col sm="2">
              <div>
                <FormGroup className="mt-2 text-left">
                  <Label>Filtrar por setor de atividade</Label>
                  <Input
                    type="select"
                    value={filtroOrdemVenda}
                    onChange={e => {
                      setFiltroOrdemVenda(e.target.value);
                    }}
                  >
                    <option value="">Selecione...</option>
                    {(() => {
                      const setores = new Set();
                      return lista
                        .filter(item => {
                          if (!item?.setorAtividade?.trim()) return false;
                          if (setores.has(item.setorAtividade)) return false;
                          setores.add(item.setorAtividade);
                          return true;
                        })
                        .map(item => (
                          <option
                            key={item.id}
                            value={item?.setorAtividade ?? ''}
                          >
                            {item.setorAtividade}
                          </option>
                        ));
                    })()}
                  </Input>
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              {isLoading ? (
                <tr>
                  <td colSpan={12}>
                    <FaSpinner className="spinner" /> Carregando...
                  </td>
                </tr>
              ) : (
                (lista ?? [])
                  ?.filter(
                    item =>
                      item.idPai === '' &&
                      (!filtroOrdemVenda ||
                        (item?.setorAtividade ?? '') ===
                          filtroOrdemVenda.toUpperCase()),
                  )
                  ?.map(item => renderListaVersao(item))
              )}
            </Col>
          </Row>
        </Card>
      </Card>
    </>
  );
}

export default GerarGNF;
